import { AccountingPackage } from "./strongbox.financialportal";

declare const _accountingPackageNameId: unique symbol;
export type AccountingPackageNameId = string & {} & { readonly [_accountingPackageNameId]: never };

export function toAccountingPackageNameId(value: string | AccountingPackage | null | undefined): AccountingPackageNameId {
    if (!value) {
        return '' as AccountingPackageNameId;
    }
    if (typeof value === "string") {
        return (value?.toLowerCase() ?? '') as AccountingPackageNameId;
    }
    return toAccountingPackageNameId(value?.nameId);
}

export function resolveAccountingPackage(nameId: string, accountingPackages: AccountingPackage[]): Maybe<AccountingPackage> {
    if (!accountingPackages || accountingPackages.length < 1) {
        return undefined;
    }
    return accountingPackages.find(x => x.nameId.toLowerCase() === nameId?.toLowerCase());
}

export function resolveAccountingPackageNameId(nameId: string, accountingPackages: AccountingPackage[]): AccountingPackageNameId {
    const resolvedAccountingPackage: Maybe<AccountingPackage> = resolveAccountingPackage(nameId, accountingPackages);
    if (!resolvedAccountingPackage) {
        return toAccountingPackageNameId(nameId);
    }
    return toAccountingPackageNameId(resolvedAccountingPackage);
}

export const UniversalCollectorAccountingPackageNameId = toAccountingPackageNameId("universalcollector");
export const ExcelUploadAccountingPackageNameId = toAccountingPackageNameId("fileupload");